import React from 'react';
import {StyleSheet, View} from 'react-native';
import {TextArea} from 'ui-kits';
import {FormikProps} from 'formik';
import {userStoryFormValuesType} from '../userStoryFormValuesType';
import { spacing } from 'theme/Units';

type propTypes = Readonly<{
  mode: 'add' | 'view' | 'edit';
}> &
  FormikProps<userStoryFormValuesType>;

export function StoryDescription(props: propTypes) {
  const {values, handleChange, errors} = props;
  return (
    <View style={styles.container}>
      <TextArea
        label="Story description"
        value={values.description}
        error={errors.description}
        onChangeText={handleChange('description')}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: spacing['3'],
  }
});
